import React from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  MenuItem,
} from '@mui/material';
import useDialog from 'hooks/useDialog';
import { ArchivedStatus } from '../ApplicationStatusControl';
import { ProfessionalArchiveReasonEnum } from 'typings/enums';
import { SelectInput, SimpleForm, Toolbar, useRecordContext } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import ScreenerAccountInput from 'components/Filter/ScreenerAccountInput';
import DateTimeInput from 'components/DateTimeInput';
import { getLatestActivePhoneScreening } from '../screeningUtils';
interface ArchiveItemProps {
  updateApplicationStatus: (val: any) => void;
}

const ArchiveToolBar = ({ closeDialog, requireScreeningFields }) => {
  const { getValues } = useFormContext();
  const values = getValues();
  const isDisabled = requireScreeningFields
    ? !values?.archive_reason || !values?.screener_account_id || !values?.scheduled_time
    : !values?.archive_reason;

  return (
    <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Button onClick={closeDialog}>Cancel</Button>
      <Button type="submit" variant="contained" color="primary" disabled={isDisabled}>
        Submit
      </Button>
    </Toolbar>
  );
};

const ArchiveItem = ({ updateApplicationStatus }: ArchiveItemProps) => {
  const { open, closeDialog, openDialog } = useDialog();

  return (
    <>
      <MenuItem onClick={openDialog}>Archive</MenuItem>
      <ArchiveDialog
        open={open}
        closeDialog={closeDialog}
        updateApplicationStatus={updateApplicationStatus}
      />
    </>
  );
};

const ArchiveDialog = ({ open, closeDialog, updateApplicationStatus }) => {
  const record = useRecordContext();
  const latestActivePhoneScreening = getLatestActivePhoneScreening(record);
  const isVerbalScreen = !!latestActivePhoneScreening;
  const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const submitUpdateApplicationStatus = ({
    archive_reason,
    screener_account_id,
    scheduled_time,
  }) => {
    updateApplicationStatus(
      isVerbalScreen
        ? {
            application_status: ArchivedStatus,
            archive_reason,
            professional_id: record?.id,
            screener_account_id,
            scheduled_time,
            reason: 'application',
            screening_type: 'phone',
          }
        : {
            application_status: ArchivedStatus,
            archive_reason,
          },
    );
  };

  const archiveReasonChoices = Object.keys(ProfessionalArchiveReasonEnum).map((key) => ({
    id: ProfessionalArchiveReasonEnum[key],
    name: key,
  }));

  return (
    <Dialog open={open} onClose={closeDialog}>
      <DialogTitle>Archive Reason</DialogTitle>
      <SimpleForm
        onSubmit={submitUpdateApplicationStatus}
        defaultValues={
          isVerbalScreen
            ? {
                screener_account_id: latestActivePhoneScreening?.screener_account_id ?? undefined,
                scheduled_time: latestActivePhoneScreening?.scheduled_time ?? undefined,
              }
            : undefined
        }
        toolbar={
          <ArchiveToolBar closeDialog={closeDialog} requireScreeningFields={isVerbalScreen} />
        }
      >
        <DialogContent>
          <SelectInput
            fullWidth
            source="archive_reason"
            label="Select Archive Reason"
            choices={archiveReasonChoices}
          />
          {isVerbalScreen && (
            <>
              <ScreenerAccountInput
                source="screener_account_id"
                label="Screening Recruiter"
                fullWidth
                alwaysOn
              />
              <DateTimeInput
                label="Screening Date And Time"
                source="scheduled_time"
                time_zone={browserTimezone}
                ampm
              />
            </>
          )}
        </DialogContent>
      </SimpleForm>
    </Dialog>
  );
};

export default ArchiveItem;
